import { ReducersTypes } from "constants/ReducersTypes";

// Initial state for thread details page
const initialThreadDetailsState = {
  loading: false,
  threadId: null,
  threadDetails: {},
  threadEmails: {
    emails: [], // Array of email objects
    currentPage: 1,
    pageSize: 20,
    hasMore: true,
    hasPrevious: false,
    totalCount: 0,
    loading: false,
    loadingDirection: null, // 'next' | 'prev' | null
    bufferSize: 60, // max items to keep in memory
    filters: {
      searchTerm: "",
      // Future filters can be added here
    },
  },
  emailSelectedForResponse: {},
  draft: {
    emailDraftOriginal: "",
    emailDraft: "",
    draftStatus: "",
    reviewerNote: "",
    loading: false,
  },
};

const threadDetailsReducer = (state = initialThreadDetailsState, action) => {
  switch (action.type) {
    // Thread Summary Actions
    case ReducersTypes["SET_THREAD_DETAILS_LOADING"]:
      return {
        ...state,
        loading: action.payload,
      };

    case ReducersTypes["SET_COLLECTOR_INBOX_THREAD_DETAILS"]:
      return {
        ...state,
        threadId: action.payload.id,
        threadDetails: action.payload || {},
      };

    case ReducersTypes["RESET_THREAD_DETAILS"]:
      return initialThreadDetailsState;

    // Email Items Actions (Section 2)
    case ReducersTypes["SET_THREAD_EMAILS"]:
      return {
        ...state,
        threadEmails: {
          ...state.threadEmails,
          emails: action.payload.emails || [],
          currentPage: action.payload.page || action.payload.currentPage || 1,
          hasMore: action.payload.next_num !== null,
          hasPrevious: action.payload.prev_num !== null,
          totalCount: action.payload.total || 0,
        },
      };

    case ReducersTypes["APPEND_THREAD_EMAILS"]:
      return {
        ...state,
        threadEmails: {
          ...state.threadEmails,
          emails: action.payload.emails, // Already includes buffering logic from action
          currentPage: action.payload.currentPage,
          hasMore: action.payload.hasMore,
          hasPrevious:
            action.payload.hasPrevious !== undefined
              ? action.payload.hasPrevious
              : true,
          totalCount:
            action.payload.totalCount || state.threadEmails.totalCount,
          loading: false,
          loadingDirection: null,
        },
      };

    case ReducersTypes["PREPEND_THREAD_EMAILS"]:
      return {
        ...state,
        threadEmails: {
          ...state.threadEmails,
          emails: action.payload.emails, // Already includes buffering logic from action
          currentPage: action.payload.currentPage,
          hasPrevious: action.payload.hasPrevious,
          hasMore:
            action.payload.hasMore !== undefined
              ? action.payload.hasMore
              : true,
          totalCount:
            action.payload.totalCount || state.threadEmails.totalCount,
          loading: false,
          loadingDirection: null,
        },
      };

    case ReducersTypes["SET_THREAD_EMAILS_LOADING"]:
      return {
        ...state,
        threadEmails: {
          ...state.threadEmails,
          loading: action.payload.loading,
          loadingDirection: action.payload.direction,
        },
      };

    case ReducersTypes["SET_THREAD_EMAILS_FILTERS"]:
      return {
        ...state,
        threadEmails: {
          ...state.threadEmails,
          filters: { ...state.threadEmails.filters, ...action.payload },
        },
      };
    case ReducersTypes["SET_EMAIL_READ_STATUS"]: {
      const updatedEmails = state.threadEmails.emails.map((email) =>
        email.id === action.payload.emailId ? { ...email, read: true } : email
      );
      return {
        ...state,
        threadEmails: {
          ...state.threadEmails,
          emails: updatedEmails,
        },
      };
    }
    case ReducersTypes["SET_DRAFT_REPLY"]:
      return {
        ...state,
        draft: {
          ...state.draft,
          emailDraftOriginal: action.payload?.draft_body || "",
          emailDraft: action.payload?.draft_body || "",
          draftStatus: action.payload?.draft_status || "",
          reviewerNote: action.payload?.reviewer_note || "",
          loading: false,
        },
      };

    case ReducersTypes["RESET_DRAFT_REPLY"]:
      return {
        ...state,
        draft: {
          ...state.draft,
          emailDraftOriginal: "",
          emailDraft: state.draft?.emailDraftOriginal || "",
          draftStatus: "",
          reviewerNote: "",
          loading: false,
        },
      };
    case ReducersTypes["SET_DRAFT_REPLY_LOADING"]:
    case ReducersTypes["SET_APPROVE_AND_SEND_LOADING"]:
      return {
        ...state,
        draft: {
          ...state.draft,
          loading: action.payload,
        },
      };
    case ReducersTypes["SET_DRAFT_REPLY_IN_DRAFT"]:
      return {
        ...state,
        draft: {
          ...state.draft,
          emailDraft: action.payload?.message || "",
        },
      };
    case ReducersTypes["SET_EMAIL_SELECTED_FOR_RESPONSE"]:
      return {
        ...state,
        emailSelectedForResponse: action.payload || null,
      };

    default:
      return state;
  }
};

export default threadDetailsReducer;
